export default __webpack_public_path__ + "static/media/good.545f986d.png";